<template>
  <form v-if="!created" @submit.prevent="submitForm" class="space-y-6 bg-white dark:bg-gray-900 p-6 rounded-lg shadow">
    <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Nový zákazník</h2>

    <!-- Jméno -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Jméno *</label>
      <input v-model="form.name" required type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
    </div>

    <!-- Email -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
      <input v-model="form.email" type="email" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
    </div>

    <!-- Telefon -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Telefon</label>
      <input v-model="form.phone" type="tel" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
    </div>

    <!-- Výběr nebo vytvoření fakturační adresy -->
    <div class="relative" ref="billingDropdown">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Fakturační adresa</label>

<!--      <div class="mb-2 space-x-4 text-sm text-gray-700 dark:text-gray-300">-->
<!--        <label>-->
<!--          <input type="radio" value="existing" v-model="billingMode" @change="onBillingModeChange" />-->
<!--          Vybrat existující-->
<!--        </label>-->
<!--        <label>-->
<!--          <input type="radio" value="new" v-model="billingMode" @change="onBillingModeChange" />-->
<!--          Nová adresa-->
<!--        </label>-->
<!--      </div>-->

      <!-- Výběr ze seznamu -->
      <div v-if="billingMode === 'existing'">
        <button @click="billingOpen = !billingOpen"
                type="button"
                class="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm px-4 py-2 text-left text-gray-800 dark:text-gray-100 focus:outline-none">
          {{ selectedBillingLabel || 'Vyber adresu' }}
        </button>

        <div v-if="billingOpen"
             class="absolute z-10 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg max-h-80 overflow-hidden">

          <div class="p-2 border-b border-gray-200 dark:border-gray-700">
            <input
                v-model="search"
                @input="resetAndFetchAddresses"
                type="text"
                placeholder="Hledat adresu..."
                class="w-full px-2 py-1 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600"
            />
          </div>

          <div class="max-h-56 overflow-y-auto" @scroll.passive="handleScrollBilling">
            <ul>
              <li v-for="address in addresses" :key="address.id"
                  @click="selectBilling(address)"
                  class="cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-gray-100">
                {{ formatAddress(address) }}
              </li>
            </ul>
            <div v-if="loading" class="py-2 px-4 text-sm text-gray-500 dark:text-gray-400 text-center animate-pulse">
              Načítám…
            </div>
          </div>
        </div>
      </div>

<!--      &lt;!&ndash; Formulář pro novou adresu &ndash;&gt;-->
<!--      <div v-if="billingMode === 'new'" class="space-y-2 mt-2">-->
<!--        <input v-model="form.addresses.billing.street" placeholder="Ulice" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.city" placeholder="Město" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.zip" placeholder="PSČ" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.country" placeholder="Země" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.company" placeholder="Firma" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.ico" placeholder="IČO" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.billing.dic" placeholder="DIČ" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--      </div>-->
    </div>






    <!-- Výběr nebo vytvoření doručovací adresy -->
    <div class="relative" ref="shippingDropdown">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Doručovací adresa</label>

<!--      <div class="mb-2 space-x-4 text-sm text-gray-700 dark:text-gray-300">-->
<!--        <label>-->
<!--          <input type="radio" value="existing" v-model="shippingMode" @change="onShippingModeChange" />-->
<!--          Vybrat existující-->
<!--        </label>-->
<!--        <label>-->
<!--          <input type="radio" value="new" v-model="shippingMode" @change="onShippingModeChange" />-->
<!--          Nová adresa-->
<!--        </label>-->
<!--      </div>-->

      <!-- Výběr ze seznamu -->
      <div v-if="shippingMode === 'existing'">
        <button @click="shippingOpen = !shippingOpen"
                type="button"
                class="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm px-4 py-2 text-left text-gray-800 dark:text-gray-100 focus:outline-none">
          {{ selectedShippingLabel || 'Vyber adresu' }}
        </button>

        <div v-if="shippingOpen"
             class="absolute z-10 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg max-h-80 overflow-hidden">

          <div class="p-2 border-b border-gray-200 dark:border-gray-700">
            <input
                v-model="search"
                @input="resetAndFetchAddresses"
                type="text"
                placeholder="Hledat adresu..."
                class="w-full px-2 py-1 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600"
            />
          </div>

          <div class="max-h-56 overflow-y-auto" @scroll.passive="handleScrollShipping">
            <ul>
              <li v-for="address in addresses" :key="address.id"
                  @click="selectShipping(address)"
                  class="cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-gray-100">
                {{ formatAddress(address) }}
              </li>
            </ul>
            <div v-if="loading" class="py-2 px-4 text-sm text-gray-500 dark:text-gray-400 text-center animate-pulse">
              Načítám…
            </div>
          </div>
        </div>
      </div>

      <!-- Formulář pro novou adresu -->
<!--      <div v-if="shippingMode === 'new'" class="space-y-2 mt-2">-->
<!--        <input v-model="form.addresses.shipping.street" placeholder="Ulice" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.city" placeholder="Město" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.zip" placeholder="PSČ" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.country" placeholder="Země" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.company" placeholder="Firma" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.ico" placeholder="IČO" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--        <input v-model="form.addresses.shipping.dic" placeholder="DIČ" class="w-full rounded-md border px-2 py-1 dark:bg-gray-700 dark:text-white" />-->
<!--      </div>-->
    </div>




    <!-- Custom fields (prozatím jednoduchý JSON input) -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Custom Data (JSON)</label>
      <textarea v-model="customRaw" rows="3" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" placeholder='[{ "note": "zpráva" }]'></textarea>
    </div>

    <div>
      <button type="submit" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Vytvořit zákazníka</button>
    </div>
  </form>
  <div v-else>
    Zákazník byl vytvořen!
  </div>
</template>

<script lang="ts">
import {
  Address,
  AddressCreationRequest,
  CustomerCreationRequest,
  PaginatedResultAddressResponse
} from '@haxo-cz/orders-ts-client';
import { useAppStore } from '@/stores/appStore';

export default {
  name: 'CreateCustomerForm',
  data() {
    return {
      billingMode: 'existing',
      shippingMode: 'existing',
      shippingOpen: false,
      selectedShippingLabel: '',
      billingOpen: false,
      selectedBillingLabel: '',
      appStore: useAppStore(),
      addresses: [] as Address[],
      form: {
        name: '',
        email: '',
        phone: '',
        addresses: {
          billing: null as string | null | AddressCreationRequest,
          shipping: null as string | null | AddressCreationRequest
        },
        custom: [] as { [key: string]: any }[]
      } as CustomerCreationRequest,
      customRaw: '',
      search: '',
      page: 1,
      limit: 20,
      hasMore: true,
      loading: false,
      created: false,
    };
  },
  methods: {
    async submitForm() {
      try {
        this.form.custom = JSON.parse(this.customRaw || '{}');
        await this.$customersApi.createCustomer(
            this.appStore.selectedProject.spaceId,
            this.appStore.selectedProject._id,
            this.form
        ).then(response=>{
          console.log(response.data);
          this.created = true;
        });
      } catch (error: any) {
        alert('Chyba při vytváření zákazníka: ' + error);
      }
    },
    formatAddress(address: Address) {
      return `${address.country}, ${address.street || ''}, ${address.city || ''}, ${address.zip}`;
    },
    async fetchAddresses() {
      console.log("fetching addresses");
      if (this.loading || !this.hasMore) return;
      this.loading = true;
      try {
        const response = await this.$addressesApi.findAllAddresses(
            this.appStore.selectedProject.spaceId,
            this.appStore.selectedProject._id,
            this.page,
            this.limit,
            this.search
        );
        console.log(response.data);
        this.addresses.push(...response.data.data);
        this.hasMore = response.data.meta.totalCount > this.addresses.length
        console.log("has more", this.hasMore);
        this.page++;
      } catch (error) {
        console.error('Chyba při načítání adres:', error);
        this.hasMore = false;
      }
      this.loading = false;
    },
    resetAndFetchAddresses() {
      this.page = 1;
      this.hasMore = true;
      this.addresses = [];
      this.fetchAddresses();
    },
    handleScrollBilling(e: Event) {
      const el = e.target as HTMLElement;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        this.fetchAddresses();
      }
    },
    handleScrollShipping(e: Event) {
      console.log("scrolling shipping");
      const el = e.target as HTMLElement;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        this.fetchAddresses();
      }
    },
    handleClickOutside(event: MouseEvent) {
      const billing = this.$refs.billingDropdown as HTMLElement;
      const shipping = this.$refs.shippingDropdown as HTMLElement;

      if (billing && !billing.contains(event.target as Node)) {
        this.billingOpen = false;
      }

      if (shipping && !shipping.contains(event.target as Node)) {
        this.shippingOpen = false;
      }
    },
    // onBillingModeChange() {
    //   if (this.billingMode === 'new' && this.form.addresses) {
    //     this.form.addresses.billing = {
    //       street: '',
    //       city: '',
    //       zip: '',
    //       country: '',
    //       company: '',
    //       ico: '',
    //       dic: ''
    //     };
    //   } else if (this.billingMode === 'existing' && this.form.addresses) {
    //     this.form.addresses.billing = null;
    //   }
    // },
    selectBilling(address) {
      console.log("select")
      console.log(this.form)
      if(this.form.addresses){
        this.form.addresses.billing = address.id;
        this.selectedBillingLabel = this.formatAddress(address);
        this.billingOpen = false;
      }
    },
    // onShippingModeChange() {
    //   if (this.shippingMode === 'new' && this.form.addresses) {
    //     this.form.addresses.shipping = {
    //       street: '',
    //       city: '',
    //       zip: '',
    //       country: '',
    //       company: '',
    //       ico: '',
    //       dic: ''
    //     };
    //   } else if (this.shippingMode === 'existing' && this.form.addresses) {
    //     this.form.addresses.shipping = null;
    //   }
    // },
    selectShipping(address: any) {
      if(this.form.addresses){
        this.form.addresses.shipping = address.id;
        this.selectedShippingLabel = this.formatAddress(address);
        this.shippingOpen = false;
      }
    }
  },
  mounted() {
    this.fetchAddresses();
    document.addEventListener('mousedown', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  },
};
</script>
